import { all } from 'redux-saga/effects'
import resource from '../../../../../redux/sagas/resource'
import * as api from '../../../../../lib/api'

export default function* rootSaga() {
  yield all([resource(api)])
}
